<ng-container [formGroup]="form">
	<mat-slide-toggle [labelPosition]="labelPosition" [formControl]="form.controls[controlName]" [color]="color">
		{{ label }}
	</mat-slide-toggle>

	<div *ngIf="hint" class="input-hint">{{ hint }}</div>
</ng-container>
